module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")]), _vm._v(" "), (this.entity.id) ? _c('div', {
    on: {
      "click": _vm.clone
    }
  }, [_vm._v("Clone")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-right hide-small"
  }, [_c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))]), _vm._v(" "), _c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show-small dropdown-admin-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Main details\n          "), (_vm.tab === 'main') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]), _vm._v(" "), (this.entity.id) ? _c('li', {
    on: {
      "click": _vm.clone
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Clone\n        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [(_vm.entity.id) ? _c('div', {
    staticClass: "col-xs-12 gap"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "shadow platform"
  }, [_c('div', {
    staticClass: "inner-tab-outer"
  }, [_c('span', {
    class: [_vm.tariffArea === 'lookup' ? 'vis' : ''],
    staticStyle: {
      "border-right": "none"
    },
    on: {
      "click": function($event) {
        _vm.tariffArea = 'lookup'
      }
    }
  }, [_vm._v("Lookup")]), _vm._v(" "), _c('span', {
    class: [_vm.tariffArea === 'detail' ? 'vis' : ''],
    on: {
      "click": function($event) {
        _vm.tariffArea = 'detail'
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('div', {
    staticClass: "inner-tab-outer"
  }, [_c('span', {
    class: [_vm.tariffArea === 'addition' ? 'vis' : ''],
    staticStyle: {
      "border-top": "none",
      "border-right": "none"
    },
    on: {
      "click": function($event) {
        _vm.tariffArea = 'addition'
      }
    }
  }, [_vm._v("Additions")]), _vm._v(" "), _c('span', {
    class: [_vm.tariffArea === 'notes' ? 'vis' : ''],
    staticStyle: {
      "border-top": "none"
    },
    on: {
      "click": function($event) {
        _vm.tariffArea = 'notes'
      }
    }
  }, [_vm._v("Notes")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tariffArea === 'addition'),
      expression: "tariffArea === 'addition'"
    }]
  }, [_c('div', {
    staticClass: "clearfix bg-wht col-xs-12"
  }, [_c('accessorials', {
    attrs: {
      "accs": _vm.accessorials,
      "lookup": this.entity.id
    },
    on: {
      "updating": function (data) { return this$1.accessorials = data; }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tariffArea === 'detail'),
      expression: "tariffArea === 'detail'"
    }]
  }, [_c('div', {
    staticClass: "clearfix bg-wht col-xs-12"
  }, [_c('tariff-details', {
    attrs: {
      "fetching": _vm.detailsPagination.fetching,
      "count": _vm.detailsPagination.count,
      "dets": _vm.details,
      "pageNumber": _vm.detailsPagination.page,
      "lookup": this.entity.id
    },
    on: {
      "loadMore": function($event) {
        return _vm.getDetails('+')
      },
      "loadBack": function($event) {
        return _vm.getDetails('-')
      },
      "updating": function (data) { return this$1.details = data; },
      "update-details-upload": _vm.updateDetails,
      "get-details": _vm.refreshDetails
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tariffArea === 'notes'),
      expression: "tariffArea === 'notes'"
    }]
  }, [_c('div', {
    staticClass: "clearfix bg-wht col-xs-12"
  }, [_c('tariff-notes', {
    attrs: {
      "notesProp": _vm.notes,
      "lookup": this.entity.id
    },
    on: {
      "updating": function (data) { return this$1.notes = data; }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tariffArea === 'lookup'),
      expression: "tariffArea === 'lookup'"
    }]
  }, [_c('Merges', {
    attrs: {
      "tariff": _vm.entity
    },
    on: {
      "goToEdit": _vm.goToEditScreen
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left top-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": "",
      "id": "tariff-id"
    },
    domProps: {
      "value": _vm.entity.id
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-code"
    }
  }, [_vm._v("Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.code),
      expression: "entity.code"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "tariff-code"
    },
    domProps: {
      "value": (_vm.entity.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-name"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "role-name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-name"
    }
  }, [_vm._v("Description *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.description),
      expression: "entity.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "tariff-name"
    },
    domProps: {
      "value": (_vm.entity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-service-class"
    }
  }, [_vm._v("Service class *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.serviceClass),
      expression: "entity.serviceClass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-service-class"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "serviceClass", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.serviceTypes), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Owner *")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": "Owner",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.owner,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": function (data) { return _vm.partySearchText = data; },
      "selection-made": _vm.selectOwner
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-lookup-type"
    }
  }, [_vm._v("Lookup Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.lookupType),
      expression: "entity.lookupType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-lookup-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "lookupType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('LOOKUP_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "is-state"
    }
  }, [_vm._v("Consolidated Service?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.consolidatedService),
      expression: "entity.consolidatedService"
    }],
    attrs: {
      "id": "is-state",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.consolidatedService) ? _vm._i(_vm.entity.consolidatedService, null) > -1 : (_vm.entity.consolidatedService)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.consolidatedService,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "consolidatedService", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "consolidatedService", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "consolidatedService", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "is-state"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-contract-name"
    }
  }, [_vm._v("Contract Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.contractName),
      expression: "entity.contractName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "tariff-contract-name"
    },
    domProps: {
      "value": (_vm.entity.contractName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "contractName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-breakpoint-per"
    }
  }, [_vm._v("Breakpoint Per")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.breakpointPer),
      expression: "entity.breakpointPer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-breakpoint-per"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "breakpointPer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('BREAKPOINT_UNIT')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-rate-per"
    }
  }, [_vm._v("Rates Per")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.ratesPer),
      expression: "entity.ratesPer"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-rate-per"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "ratesPer", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('BREAKPOINT_UNIT')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-ct"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.containerType),
      expression: "entity.containerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-ct"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "containerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('CONTAINER_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-wl"
    }
  }, [_vm._v("Wood Loose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.woodLoose),
      expression: "entity.woodLoose"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-wl"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "woodLoose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('WOOD_LOOSE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Effective From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.effectiveFrom),
      expression: "entity.effectiveFrom"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.entity.effectiveFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "effectiveFrom", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Effective To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.effectiveTo),
      expression: "entity.effectiveTo"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.entity.effectiveTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "effectiveTo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-nud"
    }
  }, [_vm._v("Next update due")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.nextUpdateDue),
      expression: "entity.nextUpdateDue"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.entity.nextUpdateDue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "nextUpdateDue", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "date-purge"
    }
  }, [_vm._v("Purge date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.purgeDate),
      expression: "entity.purgeDate"
    }],
    staticClass: "mai-date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.entity.purgeDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "purgeDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-dur-type"
    }
  }, [_vm._v("Duration type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.timeType),
      expression: "entity.timeType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-dur-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "timeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('DURATION_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-distance-type"
    }
  }, [_vm._v("Distance type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.distanceType),
      expression: "entity.distanceType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-distance-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "distanceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('DISTANCE_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-brand"
    }
  }, [_vm._v("Brand")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.brand),
      expression: "entity.brand"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-distance-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('BRAND')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-brand"
    }
  }, [_vm._v("Min. density type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.minimumDensityType),
      expression: "entity.minimumDensityType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-distance-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "minimumDensityType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('UNIT_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-unit-type"
    }
  }, [_vm._v("Unit type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.unitType),
      expression: "entity.unitType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-unit-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "unitType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('UNIT_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left bottom-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-spec-business-en"
    }
  }, [_vm._v("Specific to business entity group")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.specificToBusinessEntityGroup),
      expression: "entity.specificToBusinessEntityGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-spec-business-en"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "specificToBusinessEntityGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.partyGroups), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Specific to business entity")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": "Specific to business entity",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.specificToBusinessEntity,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": function (data) { return _vm.partySearchText = data; },
      "selection-made": _vm.selectBusinessEntity
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-spec-agent-group"
    }
  }, [_vm._v("Specific to agent group")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.specificToAgentGroup),
      expression: "entity.specificToAgentGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-spec-agent-group"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "specificToAgentGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.partyGroups), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Specific to agent")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": "Specific to agent",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.specificToAgent,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": function (data) { return _vm.partySearchText = data; },
      "selection-made": _vm.selectAgent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-min-density"
    }
  }, [_vm._v("Minimum Density")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.minimumDensity),
      expression: "entity.minimumDensity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "tariff-min-density",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.entity.minimumDensity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "minimumDensity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-min-rate"
    }
  }, [_vm._v("Minimum Rate")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.minimumRate),
      expression: "entity.minimumRate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "tariff-min-rate",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.entity.minimumRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "minimumRate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-mode"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.mode),
      expression: "entity.mode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-mode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "mode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('MODE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-shipment-type"
    }
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.shipmentType),
      expression: "entity.shipmentType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-shipment-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "shipmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('SHIPMENT_CATEGORY')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-transport-type"
    }
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.transportType),
      expression: "entity.transportType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-transport-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "transportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('TRANSPORT_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-goods-type"
    }
  }, [_vm._v("Goods Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.goodsType),
      expression: "entity.goodsType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-goods-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "goodsType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.getSystemOptions('GOODS_TYPE')), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "supress-bp"
    }
  }, [_vm._v("Suppress Breakpoints?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.suppressBreakpoints),
      expression: "entity.suppressBreakpoints"
    }],
    attrs: {
      "id": "supress-bp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.suppressBreakpoints) ? _vm._i(_vm.entity.suppressBreakpoints, null) > -1 : (_vm.entity.suppressBreakpoints)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.suppressBreakpoints,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "suppressBreakpoints", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "suppressBreakpoints", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "suppressBreakpoints", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "supress-bp"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "suspended"
    }
  }, [_vm._v("Suspended?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.suspended),
      expression: "entity.suspended"
    }],
    attrs: {
      "id": "suspended",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.suspended) ? _vm._i(_vm.entity.suspended, null) > -1 : (_vm.entity.suspended)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.suspended,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "suspended", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "suspended", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "suspended", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "suspended"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "currency"
    }
  }, [_vm._v("Lookup Currency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.lookupCurrency),
      expression: "entity.lookupCurrency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "lookupCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.currencies), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "currency"
    }
  }, [_vm._v("Pre-Carriage Currency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.preCarriageCurrency),
      expression: "entity.preCarriageCurrency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "preCarriageCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.currencies), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "currency"
    }
  }, [_vm._v("On-Carriage Currency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.onCarriageCurrency),
      expression: "entity.onCarriageCurrency"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "onCarriageCurrency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.currencies), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-max-charge"
    }
  }, [_vm._v("Maximum Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.maximumCharge),
      expression: "entity.maximumCharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "tariff-max-charge",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.entity.maximumCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "maximumCharge", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "left-join-key"
    }
  }, [_vm._v("Left Join Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.leftJoinKey),
      expression: "entity.leftJoinKey"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "left-join-key"
    },
    domProps: {
      "value": (_vm.entity.leftJoinKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "leftJoinKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "right-join-key"
    }
  }, [_vm._v("Right Join Key")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.rightJoinKey),
      expression: "entity.rightJoinKey"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "right-join-key"
    },
    domProps: {
      "value": (_vm.entity.rightJoinKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "rightJoinKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "restricted-left-join"
    }
  }, [_vm._v("Restricted Left Join?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.restrictedLeftJoin),
      expression: "entity.restrictedLeftJoin"
    }],
    attrs: {
      "id": "restricted-left-join",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.restrictedLeftJoin) ? _vm._i(_vm.entity.restrictedLeftJoin, null) > -1 : (_vm.entity.restrictedLeftJoin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.restrictedLeftJoin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "restrictedLeftJoin", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "restrictedLeftJoin", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "restrictedLeftJoin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "restricted-left-join"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "restricted-right-join"
    }
  }, [_vm._v("Restricted Right Join?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.restrictedRightJoin),
      expression: "entity.restrictedRightJoin"
    }],
    attrs: {
      "id": "restricted-right-join",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.restrictedRightJoin) ? _vm._i(_vm.entity.restrictedRightJoin, null) > -1 : (_vm.entity.restrictedRightJoin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.restrictedRightJoin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "restrictedRightJoin", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "restrictedRightJoin", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "restrictedRightJoin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "restricted-right-join"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-ext-id"
    }
  }, [_vm._v("External ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.externalId),
      expression: "entity.externalId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "tariff-ext-id",
      "step": "1"
    },
    domProps: {
      "value": (_vm.entity.externalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "externalId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tariff-category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.category),
      expression: "entity.category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tariff-category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt
      }
    }, [_vm._v(_vm._s(opt))])
  })], 2)])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Options\n      "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f661b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/Tariff.vue
// module id = 2132
// module chunks = 1